/* ==========================================================================
   VYLNS — Collection page
   Facet filtering + sorting via the Section Rendering API, so filters apply
   without a full page reload but the URL stays real and shareable.
   Degrades to standard form submission if fetch fails.
   ========================================================================== */
(function () {
  'use strict';

  function initCollection(root) {
    var wrap = (root || document).querySelector('[data-v-collection]');
    if (!wrap || wrap._bound) return;
    wrap._bound = true;

    var sectionId = wrap.dataset.vCollection;
    var grid = wrap.querySelector('[data-v-cgrid]');

    function render(url, push) {
      if (grid) grid.classList.add('is-loading');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-v-collection]');
          if (!fresh) { window.location.href = url; return; }
          wrap.innerHTML = fresh.innerHTML;
          wrap._bound = false;
          if (push) history.pushState({ url: url }, '', url);
          bind();
          window.scrollTo({ top: wrap.offsetTop - 140, behavior: 'smooth' });
        })
        .catch(function () { window.location.href = url; });
    }

    function bind() {
      var container = document.querySelector('[data-v-collection]');
      if (!container) return;

      // Facet checkboxes and price inputs submit the whole form as a query.
      var form = container.querySelector('[data-v-facet-form]');
      if (form) {
        form.addEventListener('change', function () {
          var params = new URLSearchParams(new FormData(form)).toString();
          render(window.location.pathname + '?' + params, true);
        });
      }

      // Sort is a plain select so it works without JS too.
      container.querySelectorAll('[data-v-sort]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sel.value);
          render(url.pathname + url.search, true);
        });
      });

      // Clearing a single active filter.
      container.querySelectorAll('[data-v-facet-remove]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          render(a.getAttribute('href'), true);
        });
      });

      // Keep pagination in the same no-reload flow.
      container.querySelectorAll('[data-v-page] a').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          render(a.getAttribute('href'), true);
        });
      });

      // Mirror desktop facets into the mobile drawer and back.
      container.querySelectorAll('[data-v-drawer-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = document.getElementById(btn.dataset.vDrawerOpen);
          if (!d) return;
          d.classList.add('is-open');
          d.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });
      container.querySelectorAll('[data-v-drawer-close]').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.closest('.v-dr');
          if (!d) return;
          d.classList.remove('is-open');
          d.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });
    }

    bind();
    window.addEventListener('popstate', function () { render(window.location.href, false); });
  }

  document.addEventListener('DOMContentLoaded', function () { initCollection(document); });
  document.addEventListener('shopify:section:load', function (e) { initCollection(e.target); });
})();
